import { render, staticRenderFns } from "./UserUmkmProfileView.vue?vue&type=template&id=71d9ecc0&scoped=true"
import script from "./UserUmkmProfileView.vue?vue&type=script&lang=js"
export * from "./UserUmkmProfileView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d9ecc0",
  null
  
)

export default component.exports